import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("ai4faculty_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});
